import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import LinearProgress from 'components/LinearProgress'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext/index.js'

import classes from './RatingBreakdownLink.module.scss'

/** @type {import('./types').default} */
const RatingBreakdownLink = ({ href, disabled, starRating = 0, reviews = 0, percentage = 0 }) => {
  const { addEvent } = useEventContext()
  const hasReviewsPage = !href?.includes('#reviews')

  return (
    <Link
      disableSeo
      disabled={true}
      className={clsx('RatingBreakdownLink', classes.root, { [classes.disabled]: disabled })}
      href={href}
      data-testid={`rating-breakdown-link-${starRating}`}
      {...(disabled
        ? {}
        : addEvent({
            engagementDestination: hasReviewsPage ? 'go-to_product_reviews' : 'jump-to_product_reviews',
            engagementDetails: `filter-item_overall-rating-${starRating}`,
            name: 'engagement_product_click',
          }))}
    >
      <Icon className={clsx(classes.star, { [classes.disabled]: disabled })} icon="star" size="16" />
      <Typography variant="tight-sm" className={clsx(classes.number, { [classes.disabled]: disabled })}>
        {starRating}
      </Typography>
      <div className={classes.progressContainer}>
        <LinearProgress value={percentage} className={classes.progressBar} />
      </div>
      <Typography
        variant="tight-sm"
        className={clsx(classes.number, classes.reviewNumbers, { [classes.disabled]: disabled })}
      >
        {reviews.toLocaleString()}
      </Typography>
    </Link>
  )
}

export default RatingBreakdownLink
